var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0502 9.55833L18.6318 5.13916V7.78999C15.3852 7.78999 12.4443 11.3733 12.4443 14.8608C14.0935 12.1908 15.3677 11.3258 18.6318 11.3258V13.9775L23.051 9.55833H23.0502Z",
    stroke: "#00067E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMusic);
export default __webpack_public_path__ + "static/media/share-music.e8201c1a4977c7ed374fe4d89c29df66.svg";
export { ForwardRef as ReactComponent };